import styled from 'styled-components';
import {Shadows} from '../../utils/style/shadows';
import {Responsive} from '../../utils/style/responsive';
import {Colors} from '../../utils/style/colors';
import {Paper} from "@mui/material";
import {Flex} from "../Container/Flex";

export const Wrapper = styled.div`
  position: absolute;
  top: 2px;
  bottom: 0;
  left: 2px;
  right: 2px;
  background: white;
  z-index: 1000;
  box-shadow: ${Shadows.overlay};
  ${props => props.animation !== false && `
    animation: slideIn .5s;
  `};
  transition: all .5s;
  display: flex;
  flex-direction: column;
  @keyframes slideIn {
    from {
      top: 50%;
      opacity: 0;
    }
    to {
      top: 20px;
      opacity: 1;
    }
  }
  padding: 20px;

  ${Responsive.mobile`
    	left: 5px;
    	right: 5px;
    	top: 5px;
    	
		@keyframes slideIn {
			from { top: 50%; opacity: 0; }
			to { top: 5px; opacity: 1; }
		}
    `}
`;
export const TopBar = styled(Flex)`
  flex-direction: row;
  border-bottom: 1px solid ${Colors.gray20};
  width: 100%;
  min-height: 45px;
`;
export const StateWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  > * {
    margin-right: 10px;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;

  > * {
    margin-left: 10px;
  }
`;

export const Content = styled(Flex)`
  flex: 1;
  width: 100%;
  padding: 10px 20px 10px 0;
  overflow: hidden auto;
  flex-direction: column;
`;

export const Buttons = styled(Paper)`
  width: calc(100% + 20px);
  margin-bottom: -20px;
  margin-left: -20px;
  margin-right: -20px;
  min-height: 60px;
  height: 60px;
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;